import { clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// tailwind-merge needs to know our custom theme colours so that conflicting
// classes resolve correctly (e.g. cn("bg-white", "bg-integria-green") keeps
// only the last). Registered under the v4 "color" theme scale.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      color: ["integria-green", "integria-yellow", "integria-peach", "stripe"],
    },
  },
})

// cn(...) — combine conditional class names (clsx) and resolve Tailwind
// conflicts so the last-wins (tailwind-merge). Use everywhere we build
// className strings, especially when merging a caller-supplied className.
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export default cn
